"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Svg_1 = require("./Svg");
const Path_1 = require("./Svg/Path");
const Telephone = ({ color = 'primary', ...rest }) => (React.createElement(Svg_1.default, Object.assign({}, rest, { viewBox: "0 0 46 46" }),
    React.createElement(Path_1.default, { isStroke: true, d: "M26.3 44.21c-5.775-5.788-3.727-10.302-.592-13.437l2.023-2.024a5.159 5.159 0 017.296 0l8.755 8.758a3.012 3.012 0 01-.993 4.923A30.076 30.076 0 013.569 3.211a3.012 3.012 0 014.924-.993l8.762 8.75a5.159 5.159 0 010 7.296l-2.023 2.023c-3.128 3.128-7.649 5.183-13.438-.592", color: color, strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" })));
exports.default = Telephone;
